import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { FormGroup, Label, Input, Button, Container, Row, Col } from 'reactstrap';

import Telefone from '../../components/Telefone';

import actions from './actions';

const style = {
  td: {borderTop:"1px solid #dee2e6", padding:"0.3rem"},
  th: {borderTop:"1px solid #dee2e6", borderBottom:"2px solid #dee2e6", padding:"0.3rem", fontWeight: "bold", backgroundColor: "#eff3f7"}
};

class UltimosRegistros extends Component {
  constructor (props) {
    super(props);

    this.state = {
      filteredValue: "",
      filter: {},
      expand: []
    };
  }

  componentDidMount () {
    this.props.actions.onLoadUltimosRegistrosAcesso().then(() => {
      if (0 === this.props.value.result.filter(v => moment().isSame(v.checkin, 'day')).length) {
        this.setState({filter: {semana: true}});
      }
    });
  }

  toggleFilter (index) {
    return () => {
      this.setState(state => ({
        filter: {
          ...state.filter,
          [index]: !state.filter[index]
        }
      }));
    };
  }

  toggleExpansion (id) {
    return () => {
      this.setState(state => ({
        expand: id.every((v, i) => v === state.expand[i])?[]:id
      }));
    };
  }

  handleChange = e => {
    const { value } = e.target;

    this.setState({
      filteredValue: value.replace(/^\s+|\s+(?=\s$|\s)/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase()
    });
  };

  isInFilter = v => {
    const { filteredValue } = this.state;

    return (!filteredValue || -1 < [v.contratante.apartamento, v.contratado.nome, v.contratado.funcao, v.contratado.empresa, v.contratado.telefone, v.requerente.nome.toUpperCase()].join(",").normalize('NFD').replace(/[\u0300-\u036f]/g, "").indexOf(filteredValue) || -1 < moment(v.checkin).format("HH:mm").indexOf(filteredValue));
  }

  render () {
    const { value: { result, fetching }, actions } = this.props;
    const { filter: { semana }, filteredValue, expand } = this.state;

    const filteredItems = result
    .filter(v => moment().isSame(v.checkin, 'day') && this.isInFilter(v));

    return <div>
      <br />
      <Container>
          <Row>
            <Col xs={10} style={style.th}>
            {[
              ["semana", "Exibir registros da última semana"]
            ].map((v, i) => (
              <FormGroup key={i} check inline className="d-flex justify-content-between align-items-center">
                <Label check>
                  <Input
                    type="checkbox"
                    onChange={this.toggleFilter(v[0])}
                    checked={!!this.state.filter[v[0]]}
                  />{' ' + v[1]}
                </Label>
              </FormGroup>
            ))}
            </Col>
            <Col className="text-right" style={style.th}><Button color="link" size="sm" onClick={actions.onLoadUltimosRegistrosAcesso}><span className={"fa fa-sync" + (1 === fetching?" fa-spin":"")} /></Button></Col>
          </Row>
          <Row>
            <Col style={style.th}>
              <Input placeholder="Pesquisar..." value={filteredValue} onChange={this.handleChange} />
            </Col>
          </Row>
          <Row>
            <Col xs={8} sm={4} md={3} lg={5} style={style.th}>Contratado</Col>
            <Col xs={3} className="d-none d-sm-table-cell" style={style.th}>Função</Col>
            <Col xs={2} lg={1} className="d-none d-sm-table-cell" style={style.th}>Unidade</Col>
            <Col xs={4} sm={3} md={2} lg={1} style={style.th}>Check-in + Tempo (m)</Col>
            <Col xs={2} className="d-none d-md-table-cell" style={style.th}>Requerente</Col>
          </Row>
          {filteredItems.map(v => (
            <Fragment key={v.id}>
              <Row className={v.checkout?"":"bg-warning"} onClick={this.toggleExpansion([v.id])}>
                <Col xs={8} sm={4} md={3} lg={5} style={style.td}>{v.contratado.nome}</Col>
                <Col xs={3} className="d-none d-sm-table-cell" style={style.td}>{v.contratado.funcao}</Col>
                <Col xs={2} lg={1} className="d-none d-sm-table-cell" style={style.td}>{v.contratante.apartamento?v.contratante.apartamento:'-'}</Col>
                <Col xs={4} sm={3} md={2} lg={1} style={style.td}>{moment(v.checkin).format("HH:mm")} + {v.checkout?moment.utc(moment(v.checkout).diff(v.checkin)).format("H:mm"):''}</Col>
                <Col xs={2} className="d-none d-md-table-cell" style={style.td}>{v.requerente.nome}</Col>
              </Row>
              {expand[0] === v.id && <Row>
                <Col style={style.td}><div className="form-row">
                  {!v.contratado.telefone && !v.contratado.empresa && "Não há informações a serem exibidas."}
                  {!!v.contratado.telefone && <div className="form-group col-12 col-sm-6 row">
                    <label className="col-sm-4 col-form-label">Telefone</label>
                    <div className="col-sm-8 form-control-plaintext">
                      <Telefone>{v.contratado.telefone}</Telefone>
                    </div>
                  </div>}
                  {!!v.contratado.empresa && <div className="form-group col-12 col-sm-6 row">
                    <label className="col-sm-4 col-form-label">Empresa</label>
                    <div className="col-sm-8 form-control-plaintext">
                      {v.contratado.empresa}
                    </div>
                  </div>}
                </div></Col>
              </Row>}
            </Fragment>
          ))}
          {semana && Object.values(result
          .filter(v => !moment().isSame(v.checkin, 'day') && this.isInFilter(v))
          .reduce((s, v) => {
            let key = moment(v.checkin).format('YYYY-MM-DD');
            if (!(key in s)) {
              s[key] = {
                id: key,
                label: moment(key).calendar(null, {
                  lastDay : '[Ontem]',
                  sameDay : '[Hoje]',
                  nextDay : '[Amanhã]',
                  lastWeek : 'dddd',
                  nextWeek : 'L',
                  sameElse : 'L'
                }),
                list: []
              };
            }
            s[key].list.push(v);

            return s;
          }, {})).map(g => (
            <Fragment key={g.id}>
              <Row onClick={this.toggleExpansion([g.id])}><Col style={style.th}>» {g.label}</Col></Row>
              {expand[0] === g.id && g.list.map(v => (<Fragment key={v.id}>
                <Row className={v.checkout?"":"bg-warning"} onClick={this.toggleExpansion([g.id, v.id])}>
                  <Col xs={8} sm={4} md={3} lg={5} style={style.td}>{v.contratado.nome}</Col>
                  <Col xs={3} className="d-none d-sm-table-cell" style={style.td}>{v.contratado.funcao}</Col>
                  <Col xs={2} lg={1} className="d-none d-sm-table-cell" style={style.td}>{v.contratante.apartamento?v.contratante.apartamento:'-'}</Col>
                  <Col xs={4} sm={3} md={2} lg={1} style={style.td}>{moment(v.checkin).format("HH:mm")} + {v.checkout?moment.utc(moment(v.checkout).diff(v.checkin)).format("H:mm"):''}</Col>
                  <Col xs={2} className="d-none d-md-table-cell" style={style.td}>{v.requerente.nome}</Col>
                </Row>
                {expand[1] === v.id && <Row>
                  <Col style={style.td}><div className="form-row">
                    {!v.contratado.telefone && !v.contratado.empresa && "Não há informações a serem exibidas."}
                    {!!v.contratado.telefone && <div className="form-group col-6 row">
                      <label className="col-sm-4 col-form-label">Telefone</label>
                      <div className="col-sm-8 form-control-plaintext">
                        <Telefone>{v.contratado.telefone}</Telefone>
                      </div>
                    </div>}
                    {!!v.contratado.empresa && <div className="form-group col-6 row">
                      <label className="col-sm-4 col-form-label">Empresa</label>
                      <div className="col-sm-8 form-control-plaintext">
                        {v.contratado.empresa}
                      </div>
                    </div>}
                  </div></Col>
                </Row>}
              </Fragment>))}
            </Fragment>
          ))}
      </Container></div>;
  }
}

let mapStateToProps = ({ registroAcesso: { ultimosRegistros } }) => ({
  value: ultimosRegistros
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UltimosRegistros);




// WEBPACK FOOTER //
// ./src/modules/registroAcesso/UltimosRegistros.js